var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoobiPayLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 66,
    viewBox: "0 0 51 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.366805 65.0183V25.6651C0.366805 25.6651 -0.126608 5.19162 22.0043 0.899414H50.0714V27.379C50.0714 27.379 48.461 51.0582 23.2424 50.0586V36.3266L33.7524 25.9052L38.6987 30.6867L38.8228 12.0531L19.8521 11.9511L24.8922 16.9156L11.5609 29.9993V54.0507L0.366805 65.0183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoobiPayLogoMobile);
export default __webpack_public_path__ + "static/media/MoobiPayLogo_mobile.5b5d06a0018500b18d0f0ad73b8c25f4.svg";
export { ForwardRef as ReactComponent };